import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import * as UserAttributeCode from '../../common/code/UserAttributeCode';

interface Props {
  // ラジオボタンの値
  value?: string;
}

// 初期値

export default /*@__PURE__*/_defineComponent({
  __name: 'UserAttributeRadio',
  props: {
    value: { default: UserAttributeCode.default.REAGENT }
  },
  emits: ['selectValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// 入力値
const attribute = computed({
  get: () => props.value,
  set: (value) => {
    emit('selectValue', value);
  },
});

return (_ctx: any,_cache: any) => {
  const _component_q_radio = _resolveComponent("q-radio")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(UserAttributeCode.default, (key) => {
      return (_openBlock(), _createBlock(_component_q_radio, {
        key: key,
        modelValue: attribute.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((attribute).value = $event)),
        label: UserAttributeCode.getName(key),
        val: key,
        color: "primary",
        style: {"margin-right":"10px"}
      }, null, 8, ["modelValue", "label", "val"]))
    }), 128))
  ]))
}
}

})